import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
export function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="min-h-screen bg-black text-white font-sans" data-id="element-129">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 py-16 sm:py-24" data-id="element-130">
        <Link to="/" className="inline-flex items-center gap-2 text-sm tracking-wide text-white/70 hover:text-brand-gold transition-colors duration-300 mb-12" data-id="element-131">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-132" />
          Back to pollockventures.com
        </Link>

        <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light tracking-tight mb-2" data-id="element-133">
          Terms of Service
        </h1>
        <p className="text-sm text-white/50 mb-12" data-id="element-134">
          Effective Date: May 2, 2026
        </p>

        <div className="space-y-8 text-white/80 leading-relaxed text-base" data-id="element-135">
          <p data-id="element-136">
            Welcome to www.pollockventures.com (the "Site"), operated by Pollock
            Venture Partners, LLC ("Company," "we," "us," or "our"). By
            accessing or using this Site, you agree to the following terms.
          </p>

          <Section title="1. Use of the Site" data-id="element-137">
            <p data-id="element-138">
              This Site is provided for informational purposes only. You agree
              to use the Site lawfully and not for any harmful or disruptive
              activity.
            </p>
          </Section>

          <Section title="2. No Investment Advice" data-id="element-139">
            <p data-id="element-140">
              All content on this Site is for informational purposes only and
              does not constitute:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-141">
              <li data-id="element-142">Investment advice</li>
              <li data-id="element-143">Financial advice</li>
              <li data-id="element-144">An offer to buy or sell securities</li>
            </ul>
            <p className="mt-3" data-id="element-145">
              You should consult a qualified professional before making any
              financial decisions.
            </p>
          </Section>

          <Section title="3. No Reliance" data-id="element-146">
            <p data-id="element-147">
              We make no guarantees regarding the accuracy, completeness, or
              timeliness of information on this Site. Use of the Site is at your
              own risk.
            </p>
          </Section>

          <Section title="4. Intellectual Property" data-id="element-148">
            <p data-id="element-149">
              All content on this Site, including text, branding, and design, is
              owned by Pollock Venture Partners, LLC unless otherwise stated.
            </p>
            <p className="mt-3" data-id="element-150">
              You may not copy, reproduce, or distribute content without prior
              written permission.
            </p>
          </Section>

          <Section title="5. Limitation of Liability" data-id="element-151">
            <p data-id="element-152">
              To the fullest extent permitted by law, Pollock Venture Partners,
              LLC shall not be liable for any damages arising from:
            </p>
            <ul className="list-disc pl-6 space-y-1 mt-2" data-id="element-153">
              <li data-id="element-154">Use or inability to use the Site</li>
              <li data-id="element-155">Reliance on any content</li>
              <li data-id="element-156">Errors or omissions</li>
            </ul>
          </Section>

          <Section title="6. Third-Party Links" data-id="element-157">
            <p data-id="element-158">
              The Site may include links to third-party websites. We are not
              responsible for their content or practices.
            </p>
          </Section>

          <Section title="7. Modifications" data-id="element-159">
            <p data-id="element-160">
              We may update these Terms at any time. Continued use of the Site
              constitutes acceptance of the updated Terms.
            </p>
          </Section>

          <Section title="8. Governing Law" data-id="element-161">
            <p data-id="element-162">
              These Terms are governed by the laws of the State of Delaware,
              without regard to conflict of law principles.
            </p>
          </Section>

          <Section title="9. Contact Information" data-id="element-163">
            <p data-id="element-164">Pollock Venture Partners, LLC</p>
            <p data-id="element-165">16192 Coastal Highway</p>
            <p data-id="element-166">Lewes, DE 19958</p>
            <p className="mt-3" data-id="element-167">
              Email:{' '}
              <a href="mailto:legal@pollockventures.com" className="text-brand-gold hover:underline" data-id="element-168">
                legal@pollockventures.com
              </a>
            </p>
          </Section>
        </div>
      </div>
    </main>;
}
function Section({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <section data-id="element-169">
      <h2 className="font-heading text-xl sm:text-2xl font-light tracking-tight text-white mb-3" data-id="element-170">
        {title}
      </h2>
      <div className="space-y-2" data-id="element-171">{children}</div>
    </section>;
}